import { render, staticRenderFns } from "./EmailCampaignStatistics.vue?vue&type=template&id=600b4bb0"
import script from "./EmailCampaignStatistics.vue?vue&type=script&lang=js"
export * from "./EmailCampaignStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports